import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { Button, Upload, Input, Modal } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import menuConfigurationActions from "../../../../redux/menuConfiguration/actions";
import { uploadImage } from "../../../../utils/utility";

const MenuConfigurationCategoriesEditModal = ({
  record,
  openCategoryEditModal,
  setOpenCategoryEditModal,
}) => {
  const dispatch = useDispatch();
  const organizationId = Number(localStorage.getItem("organizationId"));
  const { editCategory } = menuConfigurationActions;
  const [name, setName] = useState(null);
  const [sortIndex, setSortIndex] = useState(null);
  const [categoriesPicture, setCategoriesPicture] = useState(null);
  const base64PngUrl = "data:image/png;base64,";

  useEffect(() => {
    setName(record.name);
    setSortIndex(record.sortIndex);
    setCategoriesPicture(record.picture);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [record, openCategoryEditModal]);

  const updateCategory = () => {
    dispatch(
      editCategory({
        menuCategory: {
          id: record.id,
          name,
          sortIndex,
          pictureId: record.pictureId,
          picture: categoriesPicture?.substring(
            categoriesPicture?.indexOf(",") + 1
          ),
          // picture:null
        },
        organizationId,
      })
    );
    setOpenCategoryEditModal(false);
  };

  const closeModal = () => {
    setOpenCategoryEditModal(false);
  };

  return (
    <Modal
      className="menu-configuration-categories-edit-modal"
      onCancel={closeModal}
      centered
      open={openCategoryEditModal}
      footer={
        <div className="menu-configuration-category-edit-modal-footer">
          <Button
            className="menu-configuration-category-footer-buttons"
            onClick={closeModal}
          >
            Затвори
          </Button>
          <Button
            type="primary"
            onClick={updateCategory}
            className="menu-configuration-category-footer-buttons"
          >
            Запази
          </Button>
        </div>
      }
    >
      <div className="menu-configuration-categories-edit-container">
        <div>
          <div className="menu-configuration-categories-edit-item">
            <div className="menu-configuration-categories-edit-text-name">
              <h4>
                Име{" "}
                <span className="menu-configuration-categories-edit-name-id">
                  {record.id}
                </span>
              </h4>
            </div>
            <Input onChange={(e) => setName(e.target.value)} value={name} />
          </div>

          <div className="menu-configuration-categories-edit-item">
            <div className="menu-configuration-categories-edit-text-name">
              <h4>Сорт Индекс</h4>
            </div>
            <Input
              onChange={(e) => setSortIndex(e.target.value)}
              value={sortIndex}
            />
          </div>

          <div className="menu-configuration-categories-edit-image">
            <div className="menu-configuration-categories-image-container">
              {categoriesPicture !== null ? (
                <img
                  className="menu-configuration-categories-image"
                  src={`${base64PngUrl} ${categoriesPicture?.substring(
                    categoriesPicture?.indexOf(",") + 1
                  )}`}
                  alt="categoryImage"
                />
              ) : record.imagePath ? (
                <img
                  className="menu-configuration-categories-image"
                  src={record.imagePath}
                  alt="categoryImage"
                />
              ) : null}
            </div>
            <div>
              <Upload
                showUploadList={false}
                onChange={(e) => uploadImage(e, setCategoriesPicture)}
                accept="image/png,image/jpeg,image/webp"
                beforeUpload={() => false}
              >
                <Button
                  className="menu-configuration-categories-edit-upload-button"
                  icon={<UploadOutlined />}
                >
                  Качи файл
                </Button>
              </Upload>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default MenuConfigurationCategoriesEditModal;
